import Component from "./WellnessLanding";

export default Component;
